import {Card, SxProps} from "@mui/material";
import {ReactNode} from "react";
import {Theme} from "@emotion/react";
import {LoginPage} from "../pages/login";
const PageWrapper = ({
  children,
  sx,
}: {
  children: ReactNode | ReactNode[];
  sx?: SxProps<Theme>;
}) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        position: "relative",
        ...sx,
      }}>
      {children}
    </Card>
  );
};

export {PageWrapper, LoginPage};
